import { PDFClasses } from '../../api/objects.js';
import { MethodNotImplementedError } from '../errors.js';
class PDFObject {
    myClass() {
        return PDFClasses.PDFObject;
    }
    registerChange() {
        throw new MethodNotImplementedError(this.constructor.name, 'registerChange');
    }
    clone(_context) {
        throw new MethodNotImplementedError(this.constructor.name, 'clone');
    }
    toString() {
        throw new MethodNotImplementedError(this.constructor.name, 'toString');
    }
    sizeInBytes() {
        throw new MethodNotImplementedError(this.constructor.name, 'sizeInBytes');
    }
    copyBytesInto(_buffer, _offset) {
        throw new MethodNotImplementedError(this.constructor.name, 'copyBytesInto');
    }
}
PDFObject.className = () => PDFClasses.PDFObject;
export default PDFObject;
//# sourceMappingURL=PDFObject.js.map